/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/js/newsulan/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

	var queue = new createjs.LoadQueue();
	var stage = new createjs.Stage("scroll");
	stage.cursor="move";
	stage.enableMouseOver(10);
	createjs.Ticker.addEventListener("tick", stage);
	var canvasWidth=1266;
	var canvasHeight=444;
	var partWidth=1753;
	var imageHeight=1080;
	var imageWidth=partWidth*paints.length;
	var minScaleX=canvasWidth/imageWidth;
	var minScaleY=canvasHeight/imageHeight;
	var minScale=minScaleX>minScaleY?minScaleX:minScaleY;
	var scale=0.722;
	var posArray=[];
	scale=minScale;
	
	for(var i=0;i<paints.length;i++){
		paints[i].index=i;
		var loadItem=new createjs.LoadItem().set({
			id:"img"+i,
			src:paints[i].url,
			type:createjs.AbstractLoader.IMAGE,
			crossOrigin:"Anonymous"
		});
		queue.loadFile(loadItem);
		$(".m-nav .nav-"+paints[i].id).removeClass("lock");
		$(".m-nav .nav-"+paints[i].id).attr("data-index",i);
	}
	queue.on("complete", handleComplete, this);
	queue.load();
	
	var bitmap=new createjs.Container();
	function handleComplete(){
		stage.addChild(bitmap);
		var x=0;
		for(var i=0;i<paints.length;i++){
			var image = queue.getResult("img"+i);
			var part = new createjs.Bitmap(image);
			bitmap.addChild(part);
			part.x=x;		
			x+=image.width;
			posArray.push(x);
			part.y=0;		
		}	
		imageWidth=x;
		imageHeight=1080;
		minScaleX=canvasWidth/imageWidth;
		minScaleY=canvasHeight/imageHeight;
		minScale=minScaleX>minScaleY?minScaleX:minScaleY;
		scale=minScale;
		rouleau.init();
	}
	
	$(".m-nav .nav").click(function(){
		var index = $(this).data("index");
		$(".dragTips").fadeOut();
		moveTo(index);
		screenshot.index=index;
	})
	$(".dragTips").bind("mousedown",function(){
		$(".dragTips").fadeOut();
	})
	
	function moveTo(index){
		// var x=-index*partWidth*scale;
		var x=-posArray[index]*scale+canvasWidth;
		if(canvasWidth-x>imageWidth*scale){
			x=canvasWidth-imageWidth*scale;
		}	
		x=x>0?0:x;
		TweenMax.to(bitmap,1,{x:x});
	}
	
	var screenshot={
		el:$(".m-screenshot"),
		index:0,
		imgArray:[],
		current:0,
		init:function(){
			var _this=this;
			$(".shotBtn").click(function(){
				_this.show();
			})
			this.el.find(".closeBtn").click(function(){
				_this.close();
			})
			this.el.find(".left").click(function(){
				_this.prev();
			})
			this.el.find(".right").click(function(){
				_this.next();
			})
			this.el.click(function(e){
				if($(e.target).hasClass("point")){
					_this.goto($(e.target).index());
				}
			})
		},
		prev:function(){
			if(this.current>0){
				this.current--;
			}else{
				this.current=this.imgArray.length-1;
			}
			this.goto(this.current);
		},
		next:function(){
			if(this.current<this.imgArray.length-1){
				this.current++;
			}else{
				this.current=0;
			}
			this.goto(this.current);
		},
		goto:function(index){
			this.current=index;
			this.el.find("img").attr("src",this.imgArray[this.current]);
			this.el.find(".point").removeClass("active");
			this.el.find(".point").eq(index).addClass("active");
		},
		show:function(){
			var shotUrls=paints[this.index].shotUrls;
			this.imgArray=shotUrls.split("|");		
			var html="";
			for(var i=0;i<this.imgArray.length;i++){
				html+="<span class='point'></span>"
			}
			this.el.find(".p").html(html);
			this.current=0;		
			this.goto(0);
			this.el.fadeIn();
		},
		close:function(){
			this.el.fadeOut();
		}
	}
	$(".videoBtn").click(function(){
		addVideo("https://tianyu.v.netease.com/2017/0527/sulan.mp4");
	})
	
	function addVideo(videoUrl){
	    $(".m-video .swfCnt").flash({
	        swf: 'https://tianyu.res.netease.com/gw/14v4/player/player.swf',
	        height: '100%',
	        width: '100%',
	        allowFullScreen: true,
	        wmode: 'transparent',
	        flashvars: {
	            v1:videoUrl,
	            v2:videoUrl
	        }
	    });
	    $(".m-video").show();
	}
	
	$(".m-video .closeBtn").click(function(){
		$(".m-video").hide();
	})
	
	screenshot.init();
	var rouleau={
		el:$("#scroll"),
		isDrag:false,
		init:function(){
			var _this =this;
			var offsetX;
			var offsetY;
			var oldX=0;
			var oldY=0;
			bitmap.scaleX=bitmap.scaleY=scale;
			this.el.parent().find(".scrollInteraction").bind("mousedown",function(){
				_this.isDrag=true;			
				offsetX=stage.mouseX-bitmap.x;
				offsetY=stage.mouseY-bitmap.y;		
				$(".dragTips").fadeOut();
			})
			this.el.parent().find(".scrollInteraction").bind("mousemove",function(e){
				if(_this.isDrag){	
					bitmap.x=stage.mouseX-offsetX;
					bitmap.y=stage.mouseY-offsetY;
					checkRect();	
					var s=Math.abs(imageWidth*scale-canvasWidth);
					var h=Math.abs(bitmap.x);
					var k=Math.floor(h/s*paints.length);
					k=k>paints.length-1?paints.length-1:k;
					screenshot.index=k;		
				}			
			})
			$(document).bind("mouseup",function(){
				_this.isDrag=false;
			})
	
			this.el.parent().find(".scrollInteraction").mousewheel(function(event,detal){
				event.stopPropagation();
				event.preventDefault();
				var mouseX=event.pageX-_this.el.offset().left;
				var mouseY=event.pageY-_this.el.offset().top;
				var regX=mouseX-bitmap.x;
				var regY=mouseY-bitmap.y;
				var oldScale=scale;
				if(detal<0){
					scale-=0.02;				
					if(scale<minScale){
						scale=minScale;
					}
					bitmap.scaleX=bitmap.scaleY=scale;
				}else{
					scale+=0.02;
					scale=scale>1?1:scale;	
					bitmap.scaleX=bitmap.scaleY=scale;
				}
				var newRegX=regX/oldScale*scale;
				var newRegY=regY/oldScale*scale;
				var oX=newRegX-regX;
				var oY=newRegY-regY;
				bitmap.x-=oX;
				bitmap.y-=oY;
				checkRect();
			});
	
			function checkRect(){
				if(bitmap.x>0){
					bitmap.x=0;
				}
				if(bitmap.y>0){
					bitmap.y=0;
				}	
				if(canvasWidth-bitmap.x>imageWidth*scale){
					bitmap.x=canvasWidth-imageWidth*scale;
				}	
				if(canvasHeight-bitmap.y>imageHeight*scale){
					bitmap.y=canvasHeight-imageHeight*scale;
				}
			}	
			this.openScroll()
		},
		openScroll:function(){
			$(".dragTips").hide();
			TweenMax.set($(".mask"),{alpha:0,left:0});
			$(".mask").show();
			TweenMax.to($(".mask"),1,{alpha:1});
			TweenMax.to($(".mask"),1,{width:1394,left:0,delay:1,onComplete:function(){
				$(".dragTips").fadeIn();
				$(".shotBtn").fadeIn();
			}});
		}
	}
	


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// index.js